firebird.controller('meetingSurveyModalCtrl', [
    '$rootScope',
    '$scope',
    '$q',
    '$resource',
    '$http',
    '$window',
    '$location',
    '$timeout',
    'analyticsWrapperService',
    'logService',
    'helperService',
    'meetingService',
    'supportLinkService',
    'attendeeService',
    'meetingAPIService',
    'brandingService',
    'localizationService',
    function (
        $rootScope,
        $scope,
        $q,
        $resource,
        $http,
        $window,
        $location,
        $timeout,
        analyticsWrapperService,
        logService,
        helperService,
        meetingService,
        supportLinkService,
        attendeeService,
        meetingAPIService,
        brandingService,
        localizationService
    ) {
        var self = this;

        const logger = new LogServiceWrapper(logService, 'meetingSurveyModalCtrl');

        self.modalState = 'closed';
        self.modalTitle = localizationService.translate('LOBBY_PAGE.SURVEY.HOW_WAS_YOUR_MEETING');

        self.onShowModal = onShowModal;
        self.onHideModal = onHideModal;

        self.close = close;
        self.next = next;
        self.showNext = showNext;

        self.showThankYou = false;
        self.positiveResponse = false;

        self.rollingAnswers = [];
        self.meetingCode = helperService.getRawMeetingIdentifier($location.absUrl());

        self.currentStep = 0;

        self.responseGUID = generateGUID();

        self.showingOther = false;

        //setup for testing
        self.handlePageChange = handlePageChange;
        self.endSurvey = endSurvey;
        self.storeValueChange = storeValueChange;
        self.handleValueChange = handleValueChange;
        self.trackAnalytics = trackAnalytics;

        self.hideSocialMedia = true;
        self.getCompanyName = getCompanyName;

        self.isIntermediaPartnerUser = isIntermediaPartnerUser;
        self.getSupportLink = getSupportLink;
        self.onSupportLinkClick = onSupportLinkClick;

        self.isDiagnosticSurvey = false;
        self.isElectron = helperService.isElectron();
        self.screenCapture = undefined;
        self.stats = {};
        self.captureDiagnosticInfo = captureDiagnosticInfo;
        self.cancelSendingDiagnosticInfo = cancelSendingDiagnosticInfo;
        self.sendDiagnosticInfo = sendDiagnosticInfo;
        self.reset = reset;

        self.capturedDataForHeap = {};

        $scope.$on('show-modal', self.onShowModal);
        $scope.$on('hide-modal', self.onHideModal);

        self.endSurveyChoices = [
            localizationService.translate('LOBBY_PAGE.SURVEY.I_HAD_NO_ISSUES'),
            localizationService.translate('LOBBY_PAGE.SURVEY.I_HAD_TROUBLE_FIGURING_OUT_HOW_TO_USE_IT'),
            localizationService.translate('LOBBY_PAGE.SURVEY.I_HAD_SMALL_TECHNICAL_ISSUE'),
            localizationService.translate('LOBBY_PAGE.SURVEY.I_HAD_LARGE_TECHNICAL_ISSUE')
        ];

        self.diagnosticSurvey = [
            localizationService.translate('LOBBY_PAGE.SURVEY.I_HAD_TROUBLE_FIGURING_OUT_HOW_TO_USE_IT'),
            localizationService.translate('LOBBY_PAGE.SURVEY.I_HAD_SMALL_TECHNICAL_ISSUE'),
            localizationService.translate('LOBBY_PAGE.SURVEY.I_HAD_LARGE_TECHNICAL_ISSUE')
        ];

        self.surveyData = {
            title: '',
            showNavigationButtons: false,
            showQuestionNumbers: 'off',
            pages: [
                {
                    name: 'page1',
                    questions: [
                        {
                            type: 'radiogroup',
                            choices: self.endSurveyChoices,
                            isRequired: true,
                            name: 'step1',
                            title: localizationService.translate('LOBBY_PAGE.SURVEY.HOW_WAS_YOUR_MEETING')
                        }
                    ]
                },
                {
                    name: 'page2',
                    questions: [
                        {
                            type: 'radiogroup',
                            choices: [
                                localizationService.translate('LOBBY_PAGE.SURVEY.I_AM_IN_UNITED_STATES'),
                                localizationService.translate('LOBBY_PAGE.SURVEY.I_AM_NOT_IN_UNITED_STATES')
                            ],
                            isRequired: true,
                            name: 'step2',
                            title: localizationService.translate('LOBBY_PAGE.SURVEY.WHAT_IS_YOUR_LOCATION')
                        }
                    ]
                },
                {
                    name: 'page3',
                    questions: [
                        {
                            type: 'comment',
                            name: 'step3',
                            title: localizationService.translate('LOBBY_PAGE.SURVEY.TELL_US_WHAT_YOU_HAD_TROUBLE_WITH')
                        }
                    ]
                },
                {
                    name: 'page4',
                    questions: [
                        {
                            type: 'radiogroup',
                            choices: [
                                localizationService.translate('LOBBY_PAGE.SURVEY.AUDIO_PROBLEM'),
                                localizationService.translate('LOBBY_PAGE.SURVEY.SCREEN_SHARE_PROBLEM'),
                                localizationService.translate('LOBBY_PAGE.SURVEY.WEBCAM_PROBLEM'),
                                localizationService.translate('LOBBY_PAGE.SURVEY.CONNECTION_PROBLEM'),
                                localizationService.translate('LOBBY_PAGE.SURVEY.SLIDES_UPLOAD_PROBLEM'),
                                localizationService.translate('LOBBY_PAGE.SURVEY.OTHER_PROBLEM')
                            ],
                            isRequired: true,
                            name: 'step4',
                            title: localizationService.translate('LOBBY_PAGE.SURVEY.WHAT_KIND_OF_PROBLEM_DID_YOU_HAVE')
                        },
                        {
                            type: 'comment',
                            name: 'step4other',
                            title: localizationService.translate('LOBBY_PAGE.SURVEY.PLEASE_DESCRIBE'),
                            visibleIf:
                                "{step4}='" + localizationService.translate('LOBBY_PAGE.SURVEY.OTHER_PROBLEM') + "'"
                        },
                        {
                            type: 'comment',
                            name: 'step4SharingOther',
                            title: localizationService.translate('LOBBY_PAGE.SURVEY.PLEASE_DESCRIBE'),
                            visibleIf:
                                "{step4}='" +
                                localizationService.translate('LOBBY_PAGE.SURVEY.SCREEN_SHARE_PROBLEM') +
                                "'"
                        },
                        {
                            type: 'comment',

                            name: 'step4WebcamOther',
                            title: localizationService.translate('LOBBY_PAGE.SURVEY.PLEASE_DESCRIBE'),
                            visibleIf:
                                "{step4}='" + localizationService.translate('LOBBY_PAGE.SURVEY.WEBCAM_PROBLEM') + "'"
                        },
                        {
                            type: 'comment',
                            name: 'step4SlidesOther',
                            title: localizationService.translate('LOBBY_PAGE.SURVEY.PLEASE_DESCRIBE'),
                            visibleIf:
                                "{step4}='" +
                                localizationService.translate('LOBBY_PAGE.SURVEY.SLIDES_UPLOAD_PROBLEM') +
                                "'"
                        },
                        {
                            type: 'comment',
                            name: 'step4ConnectionOther',
                            title: localizationService.translate('LOBBY_PAGE.SURVEY.PLEASE_DESCRIBE'),
                            visibleIf:
                                "{step4}='" +
                                localizationService.translate('LOBBY_PAGE.SURVEY.CONNECTION_PROBLEM') +
                                "'"
                        }
                    ]
                },
                {
                    name: 'page5',
                    questions: [
                        {
                            type: 'radiogroup',
                            choices: [
                                localizationService.translate('COMMON.YES_TEXT'),
                                localizationService.translate('COMMON.NO_TEXT')
                            ],
                            isRequired: true,
                            name: 'step5',
                            title: localizationService.translate('LOBBY_PAGE.SURVEY.DID_YOU_DIAL_IN_ON_PHONE')
                        }
                    ]
                },
                {
                    name: 'page6',
                    questions: [
                        {
                            type: 'checkbox',
                            choices: [
                                localizationService.translate('LOBBY_PAGE.SURVEY.NO_ONE_COULD_HEAR_ME'),
                                localizationService.translate('LOBBY_PAGE.SURVEY.I_COULD_NOT_HEAR_ANYTHING'),
                                localizationService.translate('LOBBY_PAGE.SURVEY.SOME_COULD_NOT_HEAR_EACH_OTHER'),
                                localizationService.translate('LOBBY_PAGE.SURVEY.CHOPPY_OR_STUTTERED_AUDIO'),
                                localizationService.translate('LOBBY_PAGE.SURVEY.LOTS_OF_LAG_OR_DELAY'),
                                localizationService.translate('LOBBY_PAGE.SURVEY.LOTS_OF_ECHO'),
                                localizationService.translate('LOBBY_PAGE.SURVEY.VOLUME_ISSUES'),
                                localizationService.translate('LOBBY_PAGE.SURVEY.OTHER_PROBLEM')
                            ],
                            isRequired: true,
                            name: 'step6',
                            title: localizationService.translate('LOBBY_PAGE.SURVEY.WHAT_KIND_OF_AUDIO_PROBLEM')
                        },
                        {
                            type: 'comment',
                            name: 'step6other',
                            title: localizationService.translate('LOBBY_PAGE.SURVEY.PLEASE_DESCRIBE'),
                            visible: false
                        }
                    ]
                }
            ]
        };

        init();

        ////////////////////////

        function init() {
            var surveyCopy = self.surveyData;
            if (meetingService.getIsSfuEnabled() && !meetingService.isWebinar()) {
                //make a copy of surveyData because init runs multiple times
                try {
                    surveyCopy = JSON.parse(JSON.stringify(self.surveyData));
                    //the choice being removed here is for slide upload issue
                    surveyCopy.pages[3].questions[0].choices.splice(4, 1);
                    //the question being removed here is the follow up question
                    //when slide upload issue was selected
                    surveyCopy.pages[3].questions.splice(4, 1);
                } catch (err) {
                    logger.error('init', 'encountered error parsing survey data', err);
                }
            }

            Survey.Survey.cssType = 'bootstrap';
            self.survey = new Survey.Model(surveyCopy);

            var container = $window.angular.element('#surveyContainer');

            container.Survey({
                model: self.survey,
                data: {},
                onCurrentPageChanged: handlePageChange,
                onValueChanged: handleValueChange
            });
        }

        //we only show the next buttons in certain conditions.  when the next button is clicked, it should
        //perform certain actions.  as it turns out, those are currently just endSurvey, but I left them split up
        //just in case.
        function next() {
            if (self.currentStep === 6) {
                self.endSurvey();
            }

            if (self.currentStep === 4 && self.showingOther) {
                self.endSurvey();
            }

            if (self.currentStep === 3) {
                self.endSurvey();
            }
        }

        //to match current survey behavior we only show the next button in certain conditions
        function showNext() {
            if (self.showThankYou) {
                return false;
            }

            if (self.showingOther) {
                return true;
            }

            if (self.survey.currentPageNo === 2 || self.survey.currentPageNo === 5) {
                return true;
            }

            return false;
        }

        function close() {
            logService.log('user closed the survey');
            self.onHideModal(null, 'meetingSurvey');
            if (!self.isDiagnosticSurvey) {
                $rootScope.$broadcast('survey-completed');
            }
        }

        function onShowModal(e, modalName, isDiagnosticSurvey) {
            if (modalName === 'meetingSurvey') {
                analyticsWrapperService.eventTrack('Customer Experience - Survey Shown');

                self.isDiagnosticSurvey = isDiagnosticSurvey ? true : false;
                self.surveyData.pages[0].questions[0].choices = self.isDiagnosticSurvey
                    ? self.diagnosticSurvey
                    : self.endSurveyChoices;
                self.reset();

                if (helperService.isElectron() && self.isDiagnosticSurvey) {
                    self.captureDiagnosticInfo().then(capturedStats => {
                        self.stats = capturedStats;
                        takeScreenshot();
                    });
                } else {
                    self.modalState = 'open';
                    digest();
                }
            }
        }

        function takeScreenshot() {
            var capturePageCallback = function (pageImageDataURL) {
                self.screenCapture = pageImageDataURL;
                self.modalState = 'open';
                digest();
            };

            //take a screenshot before showing modal in electron
            $timeout(function () {
                $window.preloadedApi.remote.capturePage().then(capturePageCallback);
            }, 200);
        }

        function captureDiagnosticInfo() {
            let stats = {};
            return Promise.all([
                $window.preloadedApi.remote.getProcessMemoryInfo(),
                $window.preloadedApi.remote.getCPUUsage(),
                $window.preloadedApi.remote.getSystemMemoryInfo(),
                $window.preloadedApi.remote.getAllDisplays(),
                $window.preloadedApi.remote.getOsInfo()
            ])
                .then(([processMemoryInfo, cpuUsage, systemMemoryInfo, displays, osInfo]) => {
                    stats.processMemoryInfo = processMemoryInfo;
                    stats.cpuUsage = cpuUsage;
                    stats.systemMemoryInfo = systemMemoryInfo;
                    stats.displays = displays;

                    stats.os = {};
                    stats.os.arch = osInfo.arch;
                    stats.os.cpus = osInfo.cpus;
                    stats.os.freemem = osInfo.freemem;
                    stats.os.loadavg = osInfo.loadavg;
                    stats.os.platform = osInfo.platform;
                    stats.os.totalmem = osInfo.totalmem;
                    stats.os.uptime = osInfo.uptime;
                    return stats;
                })
                .catch(error => {
                    logger.error('captureDiagnosticInfo', 'error gathering data from captureDiagnosticInfo', error);
                });
        }

        function sendDiagnosticInfo() {
            analyticsWrapperService.eventTrack('Meeting - Screenshot Feedback');
            meetingAPIService.updatedDiagnosticInfo({
                meetingCode: meetingService.getMeetingCode(),
                file: self.screenCapture,
                stats: self.stats,
                attendantId: attendeeService.getAttendantId(),
                responseGuid: self.responseGUID
            });
            self.onHideModal(null, 'meetingSurvey');
        }

        function cancelSendingDiagnosticInfo() {
            self.onHideModal(null, 'meetingSurvey');
        }

        function reset() {
            self.rollingAnswers = [];
            self.showThankYou = false;
            self.positiveResponse = false;
            self.currentStep = 0;
            self.modalTitle = self.isDiagnosticSurvey
                ? localizationService.translate('LOBBY_PAGE.SURVEY.WHAT_SEEMS_TO_BE_THE_PROBLEM')
                : localizationService.translate('LOBBY_PAGE.SURVEY.HOW_WAS_YOUR_MEETING');
            //if in diagnostic mode, capture user stats and screenshot
            //and send it to api. capture image in base64 encoding and store in db first for poc
            //will determine where we want to keep it later
            if (self.isDiagnosticSurvey) {
                //refesh responseGuid for possible multiple diagnostic report
                self.responseGUID = generateGUID();
            }
            init();
        }

        function onHideModal(e, modalName) {
            if (modalName === 'meetingSurvey') {
                self.modalState = 'closed';
            }

            if (!$scope.$$phase) {
                $scope.$digest();
            }
        }

        function trackAnalytics(options) {
            switch (options.value) {
                case localizationService.translate('LOBBY_PAGE.SURVEY.I_HAD_LARGE_TECHNICAL_ISSUE'):
                    analyticsWrapperService.eventTrack('Customer Experience - Large Technical Issue');
                    self.capturedDataForHeap.mainIssueType = 'Large Technical Issue';
                    break;
                case localizationService.translate('LOBBY_PAGE.SURVEY.I_HAD_TROUBLE_FIGURING_OUT_HOW_TO_USE_IT'):
                    analyticsWrapperService.eventTrack('Customer Experience - Trouble Figuring Out How To Use It');
                    self.capturedDataForHeap.mainIssueType = 'Trouble Figuring Out How To Use It';
                    break;
                case localizationService.translate('LOBBY_PAGE.SURVEY.I_HAD_SMALL_TECHNICAL_ISSUE'):
                    analyticsWrapperService.eventTrack('Customer Experience - Small Technical Issue');
                    self.capturedDataForHeap.mainIssueType = 'Small Technical Issue';
                    break;
                case localizationService.translate('LOBBY_PAGE.SURVEY.I_HAD_NO_ISSUES'):
                    analyticsWrapperService.eventTrack('Customer Experience - Good');
                    break;
            }
        }

        function handleValueChange(sender, options) {
            self.storeValueChange(options);

            if (options.name === 'step1') {
                self.trackAnalytics(options);
            }

            if (options.name === 'step1') {
                switch (options.value) {
                    case localizationService.translate('LOBBY_PAGE.SURVEY.I_HAD_TROUBLE_FIGURING_OUT_HOW_TO_USE_IT'):
                        self.survey.currentPageNo = 1;
                        break;
                    case localizationService.translate('LOBBY_PAGE.SURVEY.I_HAD_SMALL_TECHNICAL_ISSUE'):
                    case localizationService.translate('LOBBY_PAGE.SURVEY.I_HAD_LARGE_TECHNICAL_ISSUE'):
                        self.survey.currentPageNo = 3;
                        break;
                    case localizationService.translate('LOBBY_PAGE.SURVEY.I_HAD_NO_ISSUES'):
                        self.positiveResponse = true;
                        self.endSurvey();
                        return;
                }
            }

            if (options.name === 'step2') {
                self.survey.currentPageNo = 2;
                return;
            }

            if (options.name === 'step4') {
                //if(options.value === 'Other problem...'){
                //    self.showingOther = true;
                //    return;
                //}
                if (options.value === localizationService.translate('LOBBY_PAGE.SURVEY.AUDIO_PROBLEM')) {
                    self.capturedDataForHeap.subIssueType = 'Audio Problem';
                    self.survey.currentPageNo = 4;
                    return;
                }
                self.showingOther = true;
                //self.endSurvey();
                return;
            }

            if (options.name === 'step5') {
                self.survey.currentPageNo = 5;
                return;
            }

            //The visibleIf conditions that drive the text box visility in the survey config above
            //don't seem to work in the check box case.  So, we explicity dive into an undocumented function
            //in survey component and set that visible here.  changing the location of that textbox in the list
            //requires changing it here.
            if (options.name === 'step6') {
                if (options.value === localizationService.translate('LOBBY_PAGE.SURVEY.OTHER_PROBLEM')) {
                    self.survey.getAllQuestions()[11].visible = true;
                } else {
                    self.survey.getAllQuestions()[11].visible = false;
                }
            }
        }

        function storeValueChange(options) {
            var item = {};
            item.question = options.question.title;
            item.answer = {};
            item.answer.value = options.value;

            if (options.name === 'step6other') {
                for (var i = 0; i < self.rollingAnswers.length; i++) {
                    if (
                        self.rollingAnswers[i].question ===
                        localizationService.translate('LOBBY_PAGE.SURVEY.WHAT_KIND_OF_AUDIO_PROBLEM')
                    ) {
                        self.rollingAnswers[i].answer.supplement = item.answer.value;
                        break;
                    }
                }
            } else if (
                options.name === 'step4other' ||
                options.name === 'step4SharingOther' ||
                options.name === 'step4ConnectionOther' ||
                options.name === 'step4SlidesOther' ||
                options.name === 'step4WebcamOther'
            ) {
                switch (options.name) {
                    case 'step4other':
                        self.capturedDataForHeap.subIssueType = 'Other Problem';
                        break;
                    case 'step4SharingOther':
                        self.capturedDataForHeap.subIssueType = 'Screensharing Problem';
                        break;
                    case 'step4ConnectionOther':
                        self.capturedDataForHeap.subIssueType = 'Connection Problem';
                        break;
                    case 'step4SlidesOther':
                        self.capturedDataForHeap.subIssueType = 'Slide Upload Problem';
                        break;
                    case 'step4WebcamOther':
                        self.capturedDataForHeap.subIssueType = 'Webcam Problem';
                        break;
                }
                for (var j = 0; j < self.rollingAnswers.length; j++) {
                    if (
                        self.rollingAnswers[j].question ===
                        localizationService.translate('LOBBY_PAGE.SURVEY.WHAT_KIND_OF_PROBLEM_DID_YOU_HAVE')
                    ) {
                        self.rollingAnswers[j].answer.supplement = item.answer.value;
                        break;
                    }
                }
            } else {
                var found = false;
                for (var k = 0; k < self.rollingAnswers.length; k++) {
                    if (self.rollingAnswers[k].question === item.question) {
                        found = true;
                        self.rollingAnswers[k] = item;
                        break;
                    }
                }

                if (!found) {
                    self.rollingAnswers.push(item);
                }
            }

            switch (options.name) {
                case 'step1':
                    self.currentStep = 1;
                    break;
                case 'step2':
                    self.currentStep = 2;
                    break;
                case 'step3':
                    self.currentStep = 3;
                    break;
                case 'step4':
                    self.currentStep = 4;
                    break;
                case 'step5':
                    self.currentStep = 5;
                    break;
                case 'step6':
                    self.currentStep = 6;
                    break;
            }
            postData();
        }

        function endSurvey() {
            self.currentStep = 7;
            postData();

            self.showThankYou = true;
            self.modalTitle = localizationService.translate('LOBBY_PAGE.SURVEY.THANK_YOU');

            if (self.capturedDataForHeap.mainIssueType) {
                analyticsWrapperService.eventTrack('Post-Meeting issue report submitted', {
                    issueType: self.capturedDataForHeap.mainIssueType,
                    issueReported: self.capturedDataForHeap.subIssueType,
                    issuePayload: JSON.stringify(self.rollingAnswers)
                });
            }

            if (!self.isDiagnosticSurvey) {
                $timeout(function () {
                    $rootScope.$broadcast('survey-completed');
                    self.onHideModal(null, 'meetingSurvey');
                }, 10000);
            }

            digest();
        }

        function digest() {
            if (!$scope.$$phase) {
                $scope.$digest();
            }
        }

        function getCompanyName() {
            return meetingService.getCompanyName();
        }

        function isIntermediaPartnerUser() {
            return brandingService.isPartner();
        }

        function getSupportLink() {
            return supportLinkService.getSupportLink('generic');
        }

        function handlePageChange(survey) {
            var modalTitle;

            try {
                modalTitle = survey.currentPage.questions[0].fullTitle;
            } catch (e) {
                logger.warn('handlePageChange', 'Unable to retrieve survey question title', e);
            }

            if (modalTitle) {
                self.modalTitle = modalTitle.replace('*', '').trim();
            }

            self.showingOther = false;
        }

        function generateGUID() {
            // Otherwise, just use Math.random
            // http://stackoverflow.com/questions/105034/how-to-create-a-guid-uuid-in-javascript/2117523#2117523
            return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
                var r = (Math.random() * 16) | 0,
                    v = c == 'x' ? r : (r & 0x3) | 0x8;
                return v.toString(16);
            });
        }

        /*
            This function contains a hack to turn off the authorization headers because
            it's posting to an account manager handler that can't deal with those options.
        */
        function postData() {
            var storeAuth = $http.defaults.headers.common.Authorization;
            delete $http.defaults.headers.common.Authorization;

            var surveyData = { current_fields: self.rollingAnswers };

            var data = {
                ResponseService: 'AnyMeeting',
                ResponseGUID: self.responseGUID.toUpperCase(),
                AccessCode: self.meetingCode,
                ResponseJSON: JSON.stringify(surveyData),
                CurrentStep: self.currentStep - 1,
                IsDiagnostic: self.isDiagnosticSurvey,
                AttendantID: attendeeService.getAttendantId()
            };

            var actions = {
                save: {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8' },
                    transformRequest: function (param) {
                        return $.param(param);
                    }
                }
            };

            var endpoint =
                helperService.getLocationProtocol() +
                '://www.' +
                helperService.getLocationHost() +
                '/AccountManager/Other/QualitySurveyResponseHandler.ashx';

            var deferred = $q.defer();

            $resource(endpoint, null, actions)
                .save(data)
                .$promise.then(
                    function (results) {},
                    function (err) {
                        logger.error('postData', 'error saving survey results', err);
                    }
                );

            $http.defaults.headers.common.Authorization = storeAuth;
        }

        function onSupportLinkClick() {
            meetingService.openExternalLink(supportLinkService.getSupportLink('portalsEmailNew'));
        }
    }
]);
